import React from 'react';
import { Typography } from '@material-ui/core';
import content from './content';

function CookiesDetails() {
  return (
    <div className="maxwidth">
      <Typography variant="h6">{content.title}</Typography>
      <br />
      <Typography variant="body2">{content.text}</Typography>
    </div>
  );
}

export default CookiesDetails;
